import { render, staticRenderFns } from "./OnboardingFlow.vue?vue&type=template&id=62c1c788&scoped=true&"
import script from "./OnboardingFlow.vue?vue&type=script&lang=js&"
export * from "./OnboardingFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c1c788",
  null
  
)

export default component.exports